module.exports = __webpack_public_path__ + "bf232938653692fbc0476fda549b63b0.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/header.html
// module id = 2473
// module chunks = 0